import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface CoverageRatiosInterface {
 'RESULTS.DATA.ECONOMIC_METRICS.ICR'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.DSCR'?: ResultRow;
}
export class CoverageRatios {
  'RESULTS.DATA.ECONOMIC_METRICS.ICR';
  'RESULTS.DATA.ECONOMIC_METRICS.DSCR';
  /** interest coverage ratio */
  get icr() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.ICR'];
  }
  set icr(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.ICR'] = value;
  }
  /** debt service coverage ratio */
  get dscr() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.DSCR'];
  }
  set dscr(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.DSCR'] = value;
  }
  constructor(param: CoverageRatiosInterface = {}) {
    this['RESULTS.DATA.ECONOMIC_METRICS.DSCR'] = param['RESULTS.DATA.ECONOMIC_METRICS.DSCR']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.DSCR'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.ICR'] = param['RESULTS.DATA.ECONOMIC_METRICS.ICR']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.ICR'])
      : new ResultRow();
  }

  deepCopy() {
    return new CoverageRatios(cloneDeep(this));
  }
}